<template>
  <div class="static-content-wrapper">
    <div class="content-line">
      <div class="content-line-inner">
        <h1 class="career" id="stellenangebote">Unsere aktuellen Stellenangebote</h1>
        <div class="career-offers">
          <template v-if="offers!==null&&offers!==false" v-for="offer in offers">
            <router-link :to="'/karriere/stellenangebote/'+offer?.id"
                         :class="'career-offer-wrapper career-offer-'+offer
                                     ?.attributes?.Bereich?.toLowerCase()">
              <div class="career-offer">
                <div class="career-offer-text">
                  {{ offer?.attributes?.Titel }}
                </div>
                <img class="career-offer-background"
                     :src="getImage('abt_'+offer?.attributes?.Bereich?.toLowerCase()+'.svg')"
                     v-if="offer?.attributes?.Bereich" alt="" />
                <img class="career-offer-branding" :src="getImage('logo_career_branding.svg')" alt="" />
                <div class="career-offer-custom-background" v-if="offer?.attributes?.Bild?.data"
                     :style="'background-image:url('+this.config.imageBaseUrl
                                     +(offer?.attributes?.Bild?.data?.attributes?.formats?.large?.url ??
                                     offer?.attributes?.Bild?.data?.attributes?.url ?? '')+')'" />
              </div>
            </router-link>
          </template>
          <div v-if="offers===null" class="positions-spinner-center">
            <LoadingSpinner class="career-loading-spinner" />
            <p>Daten werden geladen</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-line" style="position: relative;">
      <div class="content-line-inner">
        <h1 class="career" id="schnellbewerbung">Schnellbewerbung bei <span class="medau">MEDAU</span></h1>
        <form class="fast-apply fast-apply-initiative" @submit.prevent="submitApplication()">
          <input type="text" name="field" id="field"
                 placeholder="Das kann ich, da würde ich gerne arbeiten (optional)">
          <input type="text" name="first_name" id="first_name"
                 placeholder="Vorname*">
          <span class="form-error-apply" v-if="applicationFormErrorFirstName">
                                    Bitte geben Sie Ihren Vornamen an!</span>
          <input type="text" name="last_name" id="last_name"
                 placeholder="Nachname*">
          <span class="form-error-apply" v-if="applicationFormErrorLastName">
                                    Bitte geben Sie Ihren Nachnamen an!</span>
          <input type="text" name="mail" id="mail"
                 placeholder="E-Mail-Adresse*">
          <span class="form-error-apply" v-if="applicationFormErrorMail">
                                    Bitte geben Sie Ihre E-Mail-Adresse an!</span>
          <input type="text" name="phone" id="phone"
                 placeholder="Telefon">
          <label for="docs" id="docs-label" v-if="files.length===0">
            Bewerbungsdokumente (falls vorliegend)
          </label>
          <label for="docs" id="docs-label" v-else>
                            <span>
                                {{ files.join(", ") }}
                            </span>
          </label>
          <input type="file" multiple="multiple" name="docs" id="docs" @change="fileChange()"
                 placeholder="Bewerbungsdokumente (falls vorliegend)">
          <label class="privacy-wrapper">
            <input type="checkbox" name="privacy" id="privacy" value="ok">
            <span>
                                Ja, ich bin einverstanden, dass meine personenbezogenen Daten elektronisch erhoben und
                                gespeichert werden. Meine Daten werden nur zum Zweck der Beantwortung und Bearbeitung
                                meiner Bewerbung verwendet. Die
                                <router-link to="/seiten/datenschutz">Datenschutzhinweise</router-link>
                                habe ich zur Kenntnis genommen.*
                            </span>
          </label>
          <div class="form-error-apply" v-if="applicationFormErrorPrivacy">
            Bitte stimmen Sie der Datenverarbeitung zu!
          </div>
          <button class="fast-apply-button">Abschicken</button>
          <div class="application-messages">
            <div v-if="applicationSuccess" class="application-success">
              Bewerbung erfolgreich übertragen!
            </div>
            <div v-if="applicationFailure" class="application-error">
              Fehler! Die Bewerbung konnte nicht übertragen werden. Bitte versuchen Sie es erneut.
              Falls der Fehler bestehen bleibt, übermitteln Sie Ihre Bewerbung bitte per "Alte
              Schule".
            </div>
            <div v-if="applicationLoading" class="application-loading mail-success">
              <LoadingSpinner />
            </div>
          </div>
        </form>
        <div class="standort-detail-wrapper angebot-detail-wrapper fast-apply-benefits"
             ref="benefitsContainer" v-if="showBenefitsState">
          <div class="standort-detail" id="benefits">
            <h1>Dein Plus bei <span class="medau">Medau</span></h1>
            <div v-html="benefitsContent" />
          </div>
        </div>
      </div>
      <div :class="'fast-apply-benefits-button '+(showBenefitsState?'turned':'')" id="deinplusbeimedau"
           @click="showBenefits()">
        <img :src="getImage('plus.svg')" alt="">
      </div>
    </div>
    <MedauFooter />
  </div>
</template>

<script>
import MedauFooter from "@/components/static/MedauFooter.vue";
import {nextTick} from "vue";
import LoadingSpinner from "@/components/elements/LoadingSpinner.vue";

export default {
    data() {
        return {
            offers: null,
            autoTimeoutBenefits: null,
            showBenefitsState: false,
            benefits: null,
            applicationFormErrorPrivacy: false,
            applicationFormErrorFirstName: false,
            applicationFormErrorLastName: false,
            applicationFormErrorMail: false,
            applicationSuccess: false,
            applicationFailure: false,
            applicationLoading: false,
            files: [],
        }
    },
    components: {
        LoadingSpinner,
        MedauFooter
    },
    computed: {
        benefitsContent() {
            if(this.benefits === null) {
                return 'Benefits werden geladen...';
            }
            if(this.benefits === false) {
                return 'Fehler beim Laden der Benefits...';
            }
            return this.benefits.replace(/medau/ig, '<span class="medau">MEDAU</span>');
        }
    },
    watch: {
        async showBenefitsState(ignored_val, ignored_oldVal) {
            if(this.showBenefitsState) {
                await nextTick();
                const container = this.$refs.benefitsContainer;
                if(this.autoTimeoutBenefits !== null) {
                    clearTimeout(this.autoTimeoutBenefits);
                    this.autoTimeoutBenefits = null;
                }
                if(container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.add("open");
                container.style.height = "0px"
                setTimeout(() => {
                    container.style.height = height;
                }, 0);
                this.autoTimeoutBenefits = setTimeout(() => {
                    container.style.height = 'auto';
                }, 500);
            }
        },
    },
    methods: {
        closeBenefits() {
            const container = this.$refs.benefitsContainer;
            if(this.autoTimeoutBenefits !== null) {
                clearTimeout(this.autoTimeoutBenefits);
                this.autoTimeoutBenefits = null;
            }
            if(!container.classList.contains("open")) {
                return;
            }
            container.style.height = "auto";
            const height = container.clientHeight + "px";
            container.classList.remove("open");
            container.style.height = height;
            setTimeout(() => {
                container.style.height = '0px';
            }, 0);
            setTimeout(() => {
                this.showBenefitsState = false;
            }, 500);
        },
        showBenefits() {
            if(this.showBenefitsState) {
                this.closeBenefits();
            } else {
                this.showBenefitsState = true;
                nextTick().then(() => {
                    document.getElementById("benefits").scrollIntoView({behavior: "smooth"});
                });
            }
        },
        loadBenefits() {
            this.apiRequest('/karriere-benefits')
                .then(cnt => {
                    this.benefits = cnt.data.attributes.Inhalt;
                })
                .catch(() => this.benefits = false);
        },
        loadPositions() {
            this.apiRequest('/positions?populate=deep&sort=id:desc')
                .then(cnt => {
                    this.offers = cnt.data;
                })
                .catch(() => this.offers = false);
        },
        fileRead(file) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = function(e) {
                    const dataURL = e.target.result;
                    const parts = dataURL.split(',');
                    if(parts.length < 2) {
                        resolve();
                    }
                    resolve(parts[1]);
                };
                reader.readAsDataURL(file);
            });
        },
        async submitApplication() {
            const id = this.positionId;
            const firstName = document.getElementById("first_name").value;
            const lastName = document.getElementById("last_name").value;
            const mail = document.getElementById("mail").value;
            const phone = document.getElementById("phone").value;
            const positionText = document.getElementById("field").value;
            const files = document.getElementById("docs").files;
            const privacy = document.getElementById("privacy").checked;

            this.applicationFormErrorPrivacy = !privacy;
            this.applicationFormErrorFirstName = firstName === "";
            this.applicationFormErrorLastName = lastName === "";
            this.applicationFormErrorMail = mail === "";
            if(!privacy || firstName === "" || lastName === "" || mail === "") {
                return;
            }

            const finalFiles = [];
            for(const file of files) {
                finalFiles.push({
                    base64: await this.fileRead(file),
                    name: file.name,
                    type: file.type,
                });
            }

            this.applicationSuccess = false;
            this.applicationFailure = false;
            this.applicationLoading = true;

            this.apiRequest('/career-initiative', 'post', {
                id: id,
                firstName: firstName,
                lastName: lastName,
                mail: mail,
                phone: phone,
                files: finalFiles,
                positionText: positionText,
            }).then(cnt => {
                this.applicationLoading = false;
                if(cnt.error === false) {
                    this.applicationSuccess = true;
                    this.applicationFailure = false;

                    document.getElementById("first_name").value = "";
                    document.getElementById("last_name").value = "";
                    document.getElementById("mail").value = "";
                    document.getElementById("phone").value = "";
                    document.getElementById("field").value = "";
                    this.files = [];
                    document.getElementById("docs").value = null;
                    document.getElementById("privacy").checked = false;
                } else {
                    this.applicationSuccess = false;
                    this.applicationFailure = true;
                }
            });
        },
        fileChange() {
            const files = document.getElementById("docs").files;
            const fileNames = [];
            for(const file of files) {
                fileNames.push(file.name);
            }
            this.files = fileNames;
        }
    },
    mounted() {
        this.$store.commit("setPageTitle", "Karriere");
        document.body.classList.add("clicked");
        this.loadBenefits();
        this.loadPositions();
        if(this.$route.query.openBenefits) {
            this.showBenefits();
        }
        this.apiRequest('/karriere-seo?populate=deep')
            .then(cnt => {
                this.handleSEOObject(cnt.data?.attributes?.seo || null);
            })
            .catch();
    },
}
</script>